export function calculateTariffSelection({
    basePrice = 0,
    addons = [],
    selectedAddonIds = [],
}) {
    const selectedIds = new Set(
        selectedAddonIds
    );

    const selectedAddons = addons.filter(
        (addon) =>
            selectedIds.has(addon.id)
    );

    const selectedAddonsTotal =
        selectedAddons.reduce(
            (total, addon) =>
                total + addon.price,
            0
        );

    return {
        selectedAddons,
        selectedAddonsTotal,
        totalPrice:
            basePrice + selectedAddonsTotal,
    };
}
